export const API = {
  contactsNautica: {
    path: '/users?filters[$and][0][role][name][$eq]=Nautica&populate[id_users_nautica][populate][id_users_nautica_departments][populate][id_department][fields][0]=name_department&populate[id_users_nautica][populate][id_teams]=*&populate[id_users_role]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  contactsNotBlocked: {
    path: '/users?filters[blocked]=false&filters[$and][0][role][name][$eq]=Nautica&populate[id_users_nautica][populate][id_users_nautica_departments][populate][id_department][fields][0]=name_department&populate[id_users_nautica][populate][id_teams]=*&populate[id_users_role]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },

  contactNautica: {
    path: '/users/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => {
      return { data: data };
    },
  },

  nauticaCSV: {
    path: '/users-csv?filters[$and][0][role][name][$eq]=Nautica&populate[id_users_nautica][populate][id_users_nautica_departments][populate][id_department][fields][0]=name_department&populate[role]=name&populate[id_yacht][fields][0][1][2]=yacht_name,commercial,feedback&populate[id_users_role]=role&populate[id_users_crew]=*',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },

  create: {
    path: '/users-nauticas',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          username: body?.username,
          email: body?.email,
          surname: body?.surname,
          name: body?.name,
          id_users_role: body?.id_users_role?.id,
          phone_number: body?.phone_number,
          extension_number: body?.extension_number,
          id_site: body?.id_site,
          id_department: body?.id_department?.id,
          id_teams: body?.id_teams?.map((t) => t.id) ?? [],
        },
      };
    },
  },
  yachts: {
    path: '/yachts',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) =>
      data?.data?.map((item) => ({
        name: item.attributes.yacht_name,
        id: item.id,
      })),
  },
  selectUsersRole: {
    path: '/users-roles',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],

    transform: (data) => {
      return data?.data?.map((item) => ({
        name: item?.attributes?.role,
        id: item?.id,
      }));
    },
  },
  update: {
    path: '/users/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          username: body?.username,
          email: body?.email,
          surname: body?.surname,
          name: body?.name,
          phone_number: body?.phone_number,
          extension_number: body?.extension_number,
          id_users_role: body?.id_users_role,
          id_site: body?.id_site,
          password: body?.password,
        },
      };
    },
  },
  delete: {
    path: '/users-nauticas/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },

  selectUsersSite: {
    path: '/sites',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) => {
      return data?.data?.map((item) => ({
        name: item?.attributes?.description_site,
        id: item?.id,
      }));
    },
  },
  selectName: {
    path: '/users-nauticas?populate[id_users_permissions_user][fields]=%2A&pagination[page]=1&pagination[pageSize]=1000&sort[username_mexal]=asc&filters[id_users_permissions_user][blocked]=false',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data?.map((item) => ({
        name: `${item.attributes?.id_users_permissions_user?.data?.attributes?.name} ${item.attributes?.id_users_permissions_user?.data?.attributes?.surname}`,
        id: item.id,
      })),
  },
  drivers: {
    path: '/users-nauticas?populate[id_users_permissions_user][fields]=%2A&pagination[page]=1&pagination[pageSize]=1000&sort[username_mexal]=asc&filters[id_users_permissions_user][blocked]=false&filters[id_users_nautica_departments][id_department][short_description][$eq]=DR',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data?.map((item) => ({
        name: `${item.attributes?.id_users_permissions_user?.data?.attributes?.name} ${item.attributes?.id_users_permissions_user?.data?.attributes?.surname}`,
        id: item.id,
      })),
  },
  deliveries: {
    path: '/users-nauticas?populate[id_users_permissions_user][fields]=%2A&pagination[page]=1&pagination[pageSize]=1000&sort[username_mexal]=asc&filters[id_users_permissions_user][blocked]=false&filters[id_users_nautica_departments][id_department][short_description][$eq]=DEL',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data?.map((item) => ({
        name: `${item.attributes?.id_users_permissions_user?.data?.attributes?.name} ${item.attributes?.id_users_permissions_user?.data?.attributes?.surname}`,
        id: item.id,
      })),
  },
};
